import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Image from '../util/Image';

import { selectPageTrackingContext } from '../../selectors/client';
import { selectAlbum } from '../../selectors/album';
import { selectPlaylist } from '../../selectors/playlist';
import { selectPersonalPlaylist } from '../../selectors/personalPlaylist';
import { selectPlayerQueueOrigin } from '../../selectors/player';

import * as analyticsActions from '../../actions/analytics';
import { togglePlayPlayableItemPreview } from '../../actions/playableItemPreview';

import styles from './PreviewsModal.css';

import { QUEUE_TYPE_PERSONAL_PLAYLIST } from '../../constants';
import { PLAYABLE_ITEM_PREVIEW_DIMS, IMGIX_BASE_URL } from '../../lib/imgix';

class PreviewsModalLeftPane extends Component {
  static propTypes = {
    imageUrl: PropTypes.string,
    title: PropTypes.string,
  };
  render() {
    // Dimensions and therefore the imgix url will match PlayableItemPreview.
    // This is to reuse already loaded image (and to avoid additional loading).
    return (
      <div className={styles.albumContainer}>
        <Image
          src={this.props.imageUrl}
          width={PLAYABLE_ITEM_PREVIEW_DIMS.w}
          height={PLAYABLE_ITEM_PREVIEW_DIMS.h}
          className={styles.previewImage}
          alt={this.props.title}
        />
        <p className={styles.explanation}>
          <FormattedMessage
            id="previews-modal.explanation-2"
            defaultMessage="This is just a preview – get the full experience by creating an account for free."
          />
        </p>
      </div>
    );
  }
}

function getQueueOrigin(state) {
  const queueOrigin = selectPlayerQueueOrigin(state);
  if (queueOrigin) {
    let contentSelector = selectPlaylist;

    if (queueOrigin.type === 'QUEUE_TYPE_PERSONAL_PLAYLIST') {
      contentSelector = selectPersonalPlaylist;
    }

    if (queueOrigin.type === 'QUEUE_TYPE_ALBUM') {
      contentSelector = selectAlbum;
    }

    const content = contentSelector(state, queueOrigin.id);
    return content;
  }
  return null;
}

function getContext(state) {
  const { contextType, contextSlug, contextId } = selectPageTrackingContext(state);
  let content = null;

  if (contextType === QUEUE_TYPE_PERSONAL_PLAYLIST) {
    content = selectPersonalPlaylist(state, contextId);
  }

  if (contextType && contextSlug) {
    content =
      contextType === 'Album'
        ? selectAlbum(state, contextSlug)
        : selectPlaylist(state, contextSlug);
  }

  return content;
}

function getPreviewEntity(state) {
  const queueOrigin = getQueueOrigin(state);
  const context = getContext(state);
  return (
    queueOrigin ||
    context || {
      imageUrl: `${IMGIX_BASE_URL}/albums/IDG000000069/main.jpg`,
      title: 'Bruckner: Symphony No.8',
    }
  );
}

function mapStateToProps(state) {
  const entity = getPreviewEntity(state);
  return {
    imageUrl: entity.imageUrl,
    title: entity.title,
  };
}

export default connect(
  mapStateToProps,
  {
    analyticsTrack: analyticsActions.track,
    togglePlay: togglePlayPlayableItemPreview,
  },
  (stateProps, dispatchProps) => ({ ...stateProps, ...dispatchProps })
)(PreviewsModalLeftPane);
